module.exports = __webpack_public_path__ + "img/cmmi.21ec995a.png";